import { Store } from '@ngrx/store';
import { LocalStorage } from '../storage/local-storage';
import { Observable } from 'rxjs';
import * as Actions from '../action/header-changed.action';
import { IHeaderChangedState } from '../model/header-changed.model';
import { AppStore } from '../model/app-store.model';
import * as LocalStorageConst from './../constants/header-changed.constant';

export class AppHeaderChangedState {
  private _headerChangedStateObservable: Observable<IHeaderChangedState>;
  private _headerChangedState: IHeaderChangedState;

  constructor(private store: Store<AppStore>) {
    this._headerChangedStateObservable = this.store.select('headerChanged');

    this._headerChangedStateObservable.subscribe((HeaderChangedState) => {
      this._headerChangedState = HeaderChangedState;
    });
  }

  set stateChanged(heardChangedState: IHeaderChangedState) {
    this.store.dispatch(new Actions.HeaderChanged(heardChangedState));
    LocalStorage.setLocalObject(LocalStorageConst.HEADER_CHANGED_STATE, heardChangedState);
  }

  get stateChanged(): IHeaderChangedState {
    return this._headerChangedState;
  }

  get isGlobalHeaderEnabled(): boolean {
    return this._headerChangedState.isGlobalHeaderEnabled;
  }

}
